export const selectionModeIds = {
  PROJECTION_TYPE: 'projection-type',
  PROJECTION_SHAPE: 'projection-shape',
  PROJECTION: 'projection',
}

export const selectionModeList = [
  {
    id: selectionModeIds.PROJECTION_TYPE,
    component: 'ui-radio',
    componentFacets: ['projection-type'],
    data_model: 'projection_type',
    tooltipProps: {
      mobile: {
        originPosition: { x: 'start', y: 'start' },
        overlayPosition: { x: 'start', y: 'end' },
        position: ({ width, x, y }) => ({ x: x + width / 2, y: y + 10 }),
        transition: 'trs-to-top',
      },
      desktop: {
        originPosition: { x: 'start', y: 'start' },
        overlayPosition: { x: 'start', y: 'end' },
        position: ({ x, y }) => ({ x: x + 20, y: y + 10 }),
        transition: 'trs-to-top',
      },
    },
  },
  {
    id: selectionModeIds.PROJECTION_SHAPE,
    component: 'ui-radio',
    componentFacets: ['projection-shape'],
    data_model: 'projection_shape',
    tooltipProps: {
      mobile: {
        originPosition: { x: 'start', y: 'start' },
        overlayPosition: { x: 'start', y: 'end' },
        position: ({ x, y }) => ({ x: x + 20, y: y + 10 }),
        transition: 'trs-to-top',
      },
      desktop: {
        originPosition: { x: 'start', y: 'start' },
        overlayPosition: { x: 'start', y: 'end' },
        position: ({ x, y }) => ({ x: x + 20, y: y + 10 }),
        transition: 'trs-to-top',
      },
    },
  },
  {
    id: selectionModeIds.PROJECTION,
    component: 'ui-radio',
    componentFacets: ['projection'],
    data_model: 'projection',
    tooltipProps: {
      mobile: {
        originPosition: { x: 'start', y: 'start' },
        overlayPosition: { x: 'start', y: 'end' },
        position: ({ x, y }) => ({ x: x + 20, y: y + 15 }),
        transition: 'trs-to-top',
      },
      desktop: {
        originPosition: { x: 'start', y: 'start' },
        overlayPosition: { x: 'start', y: 'end' },
        position: ({ x, y }) => ({ x: x + 20, y: y + 15 }),
        transition: 'trs-to-top',
      },
    },
  },
]
